var render = function render(_c,_vm){return _c('div',{class:`announce-type-ward-cell d-flex align-center justify-center ${
    _vm.$options.computedStatus(_vm.props).class
  }`},[_c('div',{staticClass:"announce-type-ward-cell-inner text-center"},[_vm._v(" "+_vm._s(_vm.$options.computedStatus(_vm.props).text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }